var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card request_error",
    attrs: {
      "margin": _vm.isMargin
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _c('p', {
    staticClass: "message"
  }, [_vm.status ? [_vm._v(" Status " + _vm._s(_vm.status) + " - " + _vm._s(_vm.message) + " ")] : [_vm._v(" " + _vm._s(_vm.message) + " ")]], 2), _c('p', {
    staticClass: "copy_id"
  }, [_vm._v(" " + _vm._s(_vm.id) + " "), _c('CopyText', {
    staticClass: "copy_but",
    attrs: {
      "value": "".concat(_vm.id)
    }
  })], 1), _c('p', [_c('a', {
    attrs: {
      "href": _vm.supportURL,
      "target": "_blank"
    }
  }, [_vm._v("Submit Issue")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }